// extracted by mini-css-extract-plugin
export default {"shapka":"Ucl5SoEa","shapkaAdditional":"v7u941Gu","shapkaSearch":"R1MskBcj","desktop":"desktop"};